import { Flex, Input, Select } from 'antd';

export const BasicInfoStep = ({ handleValue, audit }) => {
  return (
    <Flex vertical gap={16}>
      <div>
        <label htmlFor="role">Your Role *</label>
        <Select
          id="role"
          style={{ width: '100%' }}
          placeholder="Select your role"
          options={[
            { label: 'Client Partner', value: 'CS' },
            { label: 'Parent Outreach', value: 'SPOT' },
            { label: 'Other', value: 'other' },
          ]}
          value={audit.role}
          onChange={(value) => handleValue('role', value)}
        />
      </div>
      <div>
        <label htmlFor="name">Your Name *</label>
        <Input
          id="name"
          placeholder="Enter your name"
          value={audit.name}
          onChange={(e) => handleValue('name', e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="title">Audit Title *</label>
        <Input
          placeholder="e.g. Family experience review"
          value={audit.title}
          onChange={(e) => handleValue('title', e.target.value)}
        />
      </div>
    </Flex>
  );
};
